import PropTypes from 'prop-types'
import React from 'react'

import {
  getFormattedOrdinals,
  getTitleAndSubtitle,
  secondsToHms,
  truncate,
} from '../../../../shared/helpers.js'
import classNames from 'classnames'

const VideoItemCaption = (props) => {
  const { view, hasFocus, hideTitle, hideMetaData, content } = props

  const { showTitle, episodeTitle } = getTitleAndSubtitle(content)

  const formattedOrdinals = getFormattedOrdinals(content, true)

  const durationFormatted = secondsToHms(content.duration)

  const metaData = durationFormatted
    ? `${formattedOrdinals} | ${durationFormatted}`
    : formattedOrdinals

  return (
    <div className="caption" itemType={view}>
      {view === 'video' && (
        <div>
          {hideTitle ? null : (
            <h3 className={`show-title`}>
              {truncate.apply(showTitle, [35, true])}
            </h3>
          )}
          <h3 className={classNames('episode-title', { focused: hasFocus })}>
            {truncate.apply(episodeTitle, [35, true])}
          </h3>
          {hideMetaData ? null : (
            <h3 className="meta-title">
              {truncate.apply(metaData, [35, true])}
            </h3>
          )}
        </div>
      )}

      {view === 'showcase' && (
        <div className="showcase-caption">
          <h3 className="showcase-title">
            {truncate.apply(showTitle, [35, true])}
          </h3>
          <h3 className="showcase-episode">
            {truncate.apply(episodeTitle, [35, true])}
          </h3>
        </div>
      )}

      {view === 'season' && (
        <span className={`season-title`}>Season {content.ordinal}</span>
      )}

      {view === 'skylab-collection' && (
        <h2 className="collection-title">
          {truncate.apply(episodeTitle, [48, true])}
        </h2>
      )}
    </div>
  )
}

VideoItemCaption.displayName = 'VideoItemCaption' // es6 need display name

VideoItemCaption.propTypes = {
  content: PropTypes.shape({
    duration: PropTypes.number,
    ordinal: PropTypes.number,
  }),
  hasFocus: PropTypes.bool,
  hideMetaData: PropTypes.bool,
  hideTitle: PropTypes.bool,
  view: PropTypes.string,
}

export default React.memo(VideoItemCaption)
